import { UseQueryResult, useQuery } from '@tanstack/react-query';

import { ProvisionalSubmissionResponse } from '../../provisionalSubmissions.types';
import { fetchProvisionalSubmission } from './useProvisionalSubmission.queries';

export const useProvisionalSubmission = (
  id: number,
): UseQueryResult<ProvisionalSubmissionResponse> => {
  return useQuery({
    queryKey: ['provisionalSubmission', id],
    queryFn: () => fetchProvisionalSubmission(id),
    enabled: Boolean(id),
  });
};
